import { http } from '../../../utils'

import { AxiosResponse } from 'axios'

export const ActionTypes = {
  GET_SITES_STOCK_SUMMARY_DATA: 'GET_SITES_STOCK_SUMMARY_DATA'
}

export const getSitesStockSummaryData = (partyId?: string) => {
  let url = '/charts/pvt/sites_stock_summary'
  if (partyId) {
    url = '/charts/pvt/sites_stock_summary?party_id='+partyId
  }
 
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export const getSitesStockSummaryDataAction = (partyId?: string) => ({
  type: ActionTypes.GET_SITES_STOCK_SUMMARY_DATA,
  promise: getSitesStockSummaryData(partyId),
})

export const getSitesStockSummaryResetAction = () => ({
  type: `${ActionTypes.GET_SITES_STOCK_SUMMARY_DATA}_RESET`
})
